export const generateSnbUrl = (currentUrl, selectedFilters, mGlobal, relatedFilter) => {
    const queryParts = currentUrl.split("?");
    const urlParts = queryParts[0].split("/");
    const lastPart = urlParts[urlParts.length - 1];
    const filterPart = lastPart.split('+');
    const filterLength = filterPart.length;
    const isSearchRequest = (filterPart[filterLength-1].indexOf('x') >= 0 || filterPart[filterLength-1].indexOf('y') >= 0) ;
    let identifierParts = filterPart[filterLength-1].split('v');
    let newFilterPart = !isSearchRequest ? [filterPart[0]] : [filterPart[0],filterPart[1]];
    
    const identifiers = [];
    const selectedFilterValues = [];
    let localityFilter = '';
    let premiumApply = false;
    
    Object.keys(selectedFilters).map((filter) => {
        if (filter === 'Premium Ads') {
            if (selectedFilters[filter][0]===1) {
                premiumApply = true;
            }
            return;
        }
        const pos = relatedFilter[filter].charCodeAt(0) - 96;
        identifiers[pos] = relatedFilter[filter];
        if (relatedFilter[filter] === 'u') {
            localityFilter = selectedFilters[filter].length > 1 ? selectedFilters[filter].join('_') : selectedFilters[filter][0] ;
        } else {
            selectedFilterValues[pos] = selectedFilters[filter].join('_');
        }
    });

    newFilterPart = newFilterPart.concat(selectedFilterValues.filter(Boolean));

    if (mGlobal === 71 || mGlobal === 72) {
        if (filterPart[filterLength-1].indexOf('u')>0) {
            newFilterPart.push(filterPart[filterLength-4]);
        } else {
            newFilterPart.push(filterPart[filterLength-3]);
        }
    }

    if (localityFilter !== '') {
        newFilterPart.push(localityFilter);
    }

    newFilterPart.push(filterPart[filterLength-2]);

    if (identifiers.length > 0) {
        identifierParts[1] = identifiers.join('');
        newFilterPart.push(identifierParts.join('v'));
    } else {
        newFilterPart.push(identifierParts[0]);
    }

    urlParts[urlParts.length - 1] = newFilterPart.join('+');
    let newUrl = urlParts.join("/");

    if (queryParts.length > 1) {
        queryParts[0] = newUrl;
        let getParams = queryParts[1].split('&');
        getParams = getParams.filter((p) => {
            if (p === 'showpremium=1' && !premiumApply) {
                return false;
            }
            return true;
            
        });
        queryParts[1] =  getParams.length>1 ? getParams.join('&') : getParams ;
        newUrl = queryParts[1] !== '' ? queryParts.join("?") : newUrl;
        if (!newUrl.match(/showpremium=1/) && premiumApply) {
            newUrl += '&showpremium=1';
        }
    } else if (premiumApply) {
        newUrl += '?showpremium=1';
    }

    return newUrl;
};

export const generateSnbSortUrl = (currentUrl, sortby) => {
    let url = currentUrl;
    if (currentUrl.indexOf('order=') >= 0) {
        url = (sortby == "") ? currentUrl.replace(/order\=[a-zA-Z\_]+/,'') : currentUrl.replace(/order\=[a-zA-Z\_]+/,'order='+sortby);
    } else {
        if (sortby != "") {
            url = (currentUrl.indexOf("?") >= 0) ? `${currentUrl}&order=${sortby}` : `${currentUrl}?order=${sortby}`;
        }
    }
    return url;
};

export const generateFeaturedSnbUrl = (currentUrl) => {
    let newUrl = '';
        
    const key = "showpremium";

    if (currentUrl.indexOf(key) >= 0) {
        const urlParts = currentUrl.split('?');
        const queryParams = urlParts[1].split('&');
        if (queryParams.length > 1) {
            delete queryParams[queryParams.indexOf(`${key}=1`)];
            const queryString = queryParams.length > 1 ? queryParams.join('&') : queryParams[0];
            urlParts[1] = queryString;
            newUrl = urlParts.join('?');
        } else {
            newUrl = urlParts[0];
        }
    } else {
        newUrl = (currentUrl.indexOf("?") >= 0) ? `${currentUrl}&${key}=1` : `${currentUrl}?${key}=1`;
    }
    return newUrl;
};

export const generateAssuredSnbUrl = (currentUrl) => {
    return (currentUrl.indexOf('refurbished') >= 0) ? currentUrl.replace(/refurbished/,'used') : currentUrl.replace(/used/,'refurbished') ;
}

export const buildNewCitySnbUrl = (id,name,match,location) => {
    location = typeof location !== 'undefined' ? location : (typeof window !== 'undefined' ? window.location : location);
    id = id*1;
    name = name.replace(/ /g,"-");
    const isAllIndia = (id === 0 || id === 1);
    const pageUrl = location.pathname;
    let matches = pageUrl.match(/[w|x|y|z](\d+)([a-zA-Z]+)?/);
    let searchMatches = pageUrl.match(/(x|y)(\d+)/);
    let isSearchUrl = (searchMatches && searchMatches.length);
    let slugParams = pageUrl.split('/')[2].split('+');
    
    let i = slugParams.indexOf("quikrcertified");
    
    if (i>-1 && matches[2]) {
        let identifiers = matches[2].split('v')[1];
        identifiers = identifiers.replace(new RegExp(identifiers[i-1]),'');
        if (identifiers == '') {
            matches[2] = '';
        } else {
            matches[2] = matches[2].replace(/n/,'');
        }
        slugParams = slugParams.filter(slug => slug!="quikrcertified");
    }
    let slugParamsLength = slugParams.length;
    
    if (isAllIndia) {
        slugParams[slugParamsLength - 1] = (isSearchUrl?'y':'z')+id+(matches[2]?matches[2]:'');
        slugParams[slugParamsLength - 2] = 'all-india';
    } else {
        slugParams[slugParamsLength - 1] = (isSearchUrl?'x':'w')+id+(matches[2]?matches[2]:'');
        slugParams[slugParamsLength - 2] = name.toLowerCase();
    }

    let queryString = location.search;
    queryString = queryString.replace(/showcertified=1/,'');
    queryString = queryString.replace(/\?&/,'?');
    queryString = queryString == '?' ? '' : queryString;
    return '/' + match.params.type + '/' + slugParams.join('+') + queryString;
}



// WEBPACK FOOTER //
// ../q-cars/src/utils/UrlHelper.js